import { Box, Container, Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { Link, Navigate } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { useDiagnosisRegistrationStore } from '../../contexts/diagnosis-registration-store-context'
import { useStyles } from './styles'

export const Finish = () => {
  const classes = useStyles()

  const diagnosisConfirmed = useDiagnosisRegistrationStore(
    (state) => state.diagnosisConfirmed,
  )

  if (!diagnosisConfirmed) {
    return <Navigate to='register' replace />
  }

  return (
    <Container className={classes.container}>
      <Box>
        <Box>
          <CheckCircleIcon />
          <Typography variant={'h1'}>Cadastro finalizado</Typography>
          <Typography variant={'h2'}>
            Os arquivos foram enviados para processamento
          </Typography>
        </Box>
      </Box>
      <Box>
        <Link to={routes.Diagnoses()}>
          <Button>Ok, finalizar</Button>
        </Link>
      </Box>
    </Container>
  )
}
